import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { noToastOnFailure } from '@core/requests/interceptors/alerts.interceptor'

@Injectable({ providedIn: 'root' })
export class I18nApi {
  private readonly _http = inject(HttpClient)

  fetchTranslations(lang: string): Observable<any> {
    return this._http.get(environment.api.translationsUrlFn(lang), {
      context: noToastOnFailure(true)
    })
  }
}
